import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const contactImporterSelectors = importerSelectors(
  'contact.importer',
);

export default contactImporterSelectors;
